import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/views/Home.vue';
import MapFull from '@/views/MapFull.vue';
import NotFound from '@/views/NotFound.vue';
import Tenants from '@/views/Tenants.vue';
import store from '@/store';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        public: true,
      },
    },
    {
      path: '/tenants',
      name: 'tenants',
      component: Tenants,
      beforeEnter: (to, from, next) => store.dispatch('tenants/getTenants')
        .then((tenants) => {
          if (tenants.length === 1) {
            return next({ name: 'map', params: { tenant_id: tenants[0].id } });
          }

          return next();
        })
        .catch(() => next()),
    },
    {
      path: '/:tenant_id/map',
      name: 'map',
      component: MapFull,
    },
    {
      path: '*',
      name: 'notfound',
      component: NotFound,
    },
  ],
});

router.beforeEach((to, from, next) => {
  const connected = store.getters['auth/connected'];

  if (!to.meta.public && !connected) {
    const query = {
      ...to.query,
      p: to.path,
    };

    return next({ name: 'home', query });
  }

  if (to.meta.public && connected) {
    return next({ name: 'tenants' });
  }

  if (to.params.tenant_id !== undefined && from !== undefined && from.params !== undefined && to.params.tenant_id !== from.params.tenant_id) {
    return store.dispatch('tenants/getCurrent', { id: to.params.tenant_id })
      .then(() => next())
      .catch(next);
  }

  return next();
});

export default router;
